import { render, staticRenderFns } from "./DocumentationSidebar.vue?vue&type=template&id=dc3dd4e2&scoped=true&"
import script from "./DocumentationSidebar.vue?vue&type=script&lang=js&"
export * from "./DocumentationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3dd4e2",
  null
  
)

export default component.exports